import { useEffect, useState } from "react";
import { usePurchaseStore } from "./purchaseStore";
export const usePassSelect = (passes, fullWidth)=>{
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuWidth, setMenuWidth] = useState(()=>fullWidth ? "100%" : null);
    const { selectedPass , setSelectedPass  } = usePurchaseStore((state)=>({
            selectedPass: state.selectedPass,
            setSelectedPass: state.setSelectedPass
        }));
    useEffect(()=>{
        if (passes.length === 0) return;
        if (selectedPass === null || !selectedPass.usable) {
            const usablePass = passes.find((pass)=>!pass.isDisabled);
            if (usablePass) {
                setSelectedPass(usablePass);
            }
            return;
        }
        // NOTE: 이용권 사용후 invalidate 되는 경우, 선택된 이용권 갱신
        const updatedPass = passes.find((pass)=>pass.id === selectedPass.id);
        if (updatedPass) {
            setSelectedPass(updatedPass);
        }
    }, [
        passes,
        selectedPass,
        setSelectedPass
    ]);
    const handleSelectClick = (event)=>{
        setAnchorEl(event.currentTarget);
        setMenuWidth(fullWidth ? "100%" : event.currentTarget.clientWidth);
    };
    const handleSelectClose = ()=>{
        setAnchorEl(null);
    };
    const handlePassSelect = (pass)=>{
        setSelectedPass(pass);
        setAnchorEl(null);
    };
    const menuListOpen = !!anchorEl;
    return {
        anchorEl,
        menuWidth,
        menuListOpen,
        handleSelectClick,
        handleSelectClose,
        handlePassSelect,
        selectedPass
    };
};
